import type { AnyAppKey } from "@/types/generatedErrorMessageKey";

import { BASE_URL } from "@/constants";
import { IS_ME_LINK, LANDING_URL } from "@/constants/app";
import i18n from "@/i18n";
import { notificationService } from "@/services/notificationService";

export interface ErrorHandler {
  messageKey: AnyAppKey;
  handle: (operationName?: string) => void | Promise<void>;
}

export const redirectToLogin = () => {
  const currentLocale = i18n.language === "en" ? "" : `/${i18n.language}`;
  const targetBack = `?targetBack=${encodeURIComponent(window.location.href)}`;
  const loginBaseUrl = IS_ME_LINK ? LANDING_URL : BASE_URL;
  window.location.href = `${loginBaseUrl}${currentLocale}/login${targetBack}`;
};

export const GLOBAL_ERROR_HANDLERS = {
  "user.not_found": "user.not_found",
  internal_error: "internal_error",
} satisfies Partial<Record<AnyAppKey, AnyAppKey>>;

export const createErrorHandlers = (): ErrorHandler[] => [
  {
    messageKey: GLOBAL_ERROR_HANDLERS["user.not_found"],
    handle: async () => {
      notificationService.danger({
        msg: i18n.t(`errors:${GLOBAL_ERROR_HANDLERS["user.not_found"]}`),
      });
      await redirectToLogin();
    },
  },
  {
    messageKey: GLOBAL_ERROR_HANDLERS.internal_error,
    handle: (operationName) => {
      notificationService.danger({
        msg: `${operationName || "Unknown Operation"}: ${i18n.t(`errors:${GLOBAL_ERROR_HANDLERS.internal_error}`)}`,
      });
    },
  },
];
